import { render, staticRenderFns } from "./ConvitesPendentes.vue?vue&type=template&id=da571502&scoped=true"
import script from "./ConvitesPendentes.vue?vue&type=script&lang=js"
export * from "./ConvitesPendentes.vue?vue&type=script&lang=js"
import style0 from "./ConvitesPendentes.vue?vue&type=style&index=0&id=da571502&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da571502",
  null
  
)

export default component.exports